export default __webpack_public_path__ + "static/media/icon5.b2de7cff.png";